import React, { useEffect, useRef, useState } from 'react'
import MainContentWrapper from '../../Components/MainContentWrapper'
import Popup from '../../ReusableFunctions/Popup'
import Loading from '../../ReusableFunctions/Loader'
import { getAllDSPs } from '../../apis/adminAPIs/dsp'
import Search from '../../ReusableComponents/Search'
import TableView from '../../ReusableComponents/TableView/TableView'
import _debounce from 'lodash/debounce';
import Filter from "../../assets/filter.svg"
import { Button } from '../../Components/Helper'
import { generateCSV } from '../../utils/generateAndDownloadCsv'
import { useNavigate } from 'react-router'
import { useSelector } from 'react-redux'
import DspFilter from '../../AdminComponents/DroneServiceProviders/SubComponents/DspFilter'
import ViewCustSuccessDsp from './ViewCustSuccessDsp'

const PAGE_SIZE = 20

const csvHeader = [
    { label: "Company Name", key: "dsp_name" },
    { label: "Company Address", key: "dsp_address" },
    { label: "Owner Name", key: "operator_name" },
    { label: "Owner Email", key: "operator_email" },
    { label: "Date Of Added", key: "dsp_date_created", isDate: true },
    { label: "Status", key: "status" },
]

const CustSuccessdsps = () => {
    const user = useSelector(state => state.user?.user)
    const navigate = useNavigate();
    const isFirstRender = useRef(true);
    const [loading, setLoading] = useState()
    const [selectedDSP, setSelectedDSP] = useState()
    const [serviceProviders, setServiceProviders] = useState([])
    const [dspsCount, setDspsCount] = useState(0)
    const [filter, setFilter] = useState(()=>{
        let savedFilters=localStorage.getItem("custSuccessDspSectionFilters");
            if(savedFilters){
                let parsedFilters = JSON.parse(savedFilters);
                return {...parsedFilters,searchString:""};
        }
        return  {
            fromDate: null,
            toDate: null,
            isActive: true,
            pageNumber:1,
            pageSize: PAGE_SIZE,
            searchString: "",
        }
    })
    const [openFilter, setOpenFilter] = useState(false)

    const getAllDSPsFunc = async () => {
        try {
            setLoading(true)
            const { fromDate, toDate, isActive,searchString,pageNumber,pageSize } = filter
            const dsps = await getAllDSPs(pageSize, pageNumber, searchString || '', fromDate, toDate, isActive)
            setServiceProviders(dsps.dsps)
            setDspsCount(dsps.count)
            setLoading(false)
        } catch (err) {
            setLoading(false)
            Popup.alert("Error", err, 'ERROR')
        }
    }

    const downloadCSV = async () => {
        Loading.set(true)
        const { fromDate, toDate, isActive,searchString,pageNumber,pageSize } = filter
        const dsps = await getAllDSPs(pageSize, pageNumber, searchString || '', fromDate, toDate, isActive)
        const data = dsps.dsps.map((d) => {
            if (d.dsp_is_active) {
                return {
                    ...d,
                    status: "Active"
                }
            }
            else {
                return {
                    ...d,
                    status: "inActive"
                }
            }
        })
        generateCSV(csvHeader, data, "output")
        Loading.set(false)
    }

    useEffect(() => {
        setLoading(true)
        getAllDSPsFunc()
        localStorage.removeItem("adminRequestFilters");
        localStorage.removeItem("cseDspDashBoardFilters");
    }, [])

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }

        const debouncedGetAllDSPs = _debounce(() => {
            getAllDSPsFunc();
            localStorage.setItem("custSuccessDspSectionFilters", JSON.stringify(filter));
        }, 3000);

        debouncedGetAllDSPs();

        return () => {
            debouncedGetAllDSPs.cancel();
        };
    }, [filter.searchString, filter.pageNumber, filter.fromDate, filter.toDate, filter.isActive]);

    return (
        <MainContentWrapper
            header={`Drone service providers (${dspsCount})`}
            rightContent={
                <div style={{ display: "flex", gap: '30px' }}>
                    <Search
                        searchValue={filter.searchString}
                        onChange={(value) => {
                            setLoading(true);
                           setFilter((prevFilters)=>({
                            ...prevFilters,
                             searchString: value,
                             pageNumber: 1
                           }))
                        }}
                    />
                    <Button
                        innerClassName={"filter-btn-inner"}
                        iconStyle={{ width: "18px", marginRight: "10px" }}
                        text={"Filter"}
                        icon={Filter}
                        className={"filter-btn"}
                        onClick={() => {
                            setOpenFilter(true)
                        }}
                        textClassName={"user-details-filter-text"}
                    />
                    {/* <Button
                        text={"Export CSV"}
                        style={{ width: "104px", height: "38px", fontSize: "15px" }}
                        onClick={() => {
                            downloadCSV()
                        }}
                    /> */}
                </div>
            }
        >
            {selectedDSP &&
                <ViewCustSuccessDsp
                    open={selectedDSP}
                    onClose={() => {
                        setSelectedDSP()
                        localStorage.setItem('dsp_id', "admin")
                    }}
                    dsp={selectedDSP}
                    callback={(dsp) => {
                        setServiceProviders(prev => prev.map(d => {
                            if (d.dsp_id === dsp.dsp_id) return dsp;
                            else return d
                        }))
                        localStorage.setItem('dsp_id', dsp.dsp_id)
                        setSelectedDSP(dsp)
                    }}
                />
            }

            {openFilter &&
                <DspFilter
                    filter={filter}
                    onFilterChange={(filter) => {
                        setOpenFilter(false)
                        setFilter((prevFilters)=>({
                            ...prevFilters,
                            ...filter,
                             pageNumber: 1,
                        }))
                    }}
                    onClose={() => setOpenFilter(false)}
                    open={openFilter}
                />
            }

            <TableView
                isLoading={loading}
                tableContainerHeight={dspsCount < 15 ? "calc(100% - 40px)" : "calc(100% - 65px)"}
                showSrNo
                onStateChange={(changedState) => {
                    setLoading(true);
                    setFilter((prevFilters)=>({
                        ...prevFilters,
                         pageNumber: changedState.pageNumber,
                    }))
                }}
                onClickRow={(dsp) => {
                    localStorage.setItem("dsp_id", dsp.dsp_id)
                    navigate('/cse/dsps/viewdsp', { state: { dsp: dsp} })
                }}
                onClickLink={(request) => { }}
                columns={[
                    { Header: "Company Name", accessor: "dsp_name", width: "10%" },
                    { Header: "Company Address", accessor: "dsp_address", width: "10%" },
                    { Header: "Owner Name", accessor: "operator_name", width: "10%" },
                    { Header: "Owner Email", accessor: "operator_email", width: "10%" },
                    { Header: "DSP Type", accessor: "is_promoted", width: "10%" },
                    { Header: "Date Of Added", accessor: "dsp_date_created", width: "10%", isDate: "true" },
                    { Header: "Status", accessor: "dsp_is_active_label", width: "5%", showColor: true },
                ]}
                data={serviceProviders.map(sp => {
                    return {
                        ...sp,
                        dsp_is_active_label: sp.dsp_is_active ? "Active" : "Inactive",
                        color: sp.dsp_is_active ? 'green' : 'red',
                        is_promoted: sp.is_dsp_promoted ? "Promoted" : "Non Promoted"
                    }
                })}
                count={dspsCount}
                pageNumber={filter.pageNumber}
                pageSize={filter.pageSize}
            />
        </MainContentWrapper>
    )
}

export default CustSuccessdsps